module.exports = __webpack_public_path__ + "img/cst_website.0dba96ba.svg";